<template>
  <div>
      <search-nav>
          <search-nav-start-end label="작성일" v-model="nav.created_at" />
          <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes" />
          <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
      </search-nav>

      <div class="flex mb-4" style="justify-content: flex-end">
      <!-- <vs-button color="secondary" type="border" @click="onClickNew"> 인쇄 </vs-button>
      <vs-button color="secondary" @click="onClickNew"> Excel 다운로드 </vs-button>
      <vs-button color="secondary" type="border" @click="onClickNew"> 결재선 지정 </vs-button> -->
          <vs-button color="secondary" @click="onClickNew"> 신규작성 </vs-button>
      </div>
      <vs-card>
          <vs-table stripe ref="table" :sst="true" :max-items="table.perPage" :data="table.list" :noDataText="$t('approval.결재문서가 없습니다')" @selected="handleItemClickDetail">
              <template slot="thead">
                  <vs-th sort-key="id" style="width: 80px"><span class="w-full text-center">No.</span></vs-th>
                  <vs-th sort-key="content$field_name" style="min-width: 130px"><span class="w-full text-center">사업장명</span></vs-th>
                  <vs-th style="min-width: 130px"><span class="w-full text-center">소속명</span></vs-th>
                  <vs-th style="min-width: 130px"><span class="w-full text-center">부서명</span></vs-th>
                  <vs-th style="min-width: 130px"><span class="w-full text-center">작성자</span></vs-th>
                  <vs-th style="min-width: 130px"><span class="w-full text-center">작성일</span></vs-th>
              </template>

              <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td class="text-center">{{ tr.id }}</vs-td>
                      <vs-td class="text-center">{{ tr.field_name }}</vs-td>
                      <vs-td class="text-center">{{ tr.address }}</vs-td>
                      <vs-td class="text-center">{{ tr.work_begin_at }} ~ {{ tr.work_end_at }}</vs-td>
                      <vs-td class="text-center">{{ tr.deposit_amount }}</vs-td>
                      <vs-td class="text-center">{{ tr.deposit_amount }}</vs-td>
                  </vs-tr>
              </template>
          </vs-table>

          <div class="vs-con-table">
              <div class="con-pagination-table vs-table--pagination">
                  <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
              </div>
          </div>
      </vs-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";

import KPagination from "@/components/kPagination/kPagination";

export default {
  name: "FieldList",
  components: {
      SearchNav,
      SearchNavStartEnd,
      SearchNavItemSelect,
      SearchNavItemKeyword,

      KPagination,
  },
  data() {
      return {
          // 검색 네비게이션
          nav: {
              created_at: "",
              searchType: "",
              searchKeyword: "",
          },
          searchTypes: [{ value: "사업장명" }, { value: "소속명" }, { value: "부서명" }, { value: "작성자" }, { value: "작성일" }],

          currentPage: 1,
          lastPage: 1,
          total: 0,
          table: {
              list: [],
              perPage: 7,
              keyword: "",
          },
      };
  },
  created() {
      this.initBreadcrumb();
  },
  computed: {
      projectId() {
          return this.$route.params.proj_id;
      },
  },
  mounted() {
      this.loadFieldList();
  },
  methods: {
      initBreadcrumb() {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "신규 사업장 등록 요청" }, { title: "발주 사업장", active: true }]);
      },
      async loadFieldList() {
          const projectId = this.projectId;

          await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId, type: "사업장(도급발주)" });
          const fieldListInfo = this.$store.state.project.fieldListInfo;
          this.table.list = fieldListInfo.data;
      },
      onClickTab(tabIndex) {
          if (tabIndex === 0) {
              this.$router.push({ name: "ep-field-field-list" });
          } else if (tabIndex === 1) {
              this.$router.push({ name: "ep-field-field-info" });
          }
      },
      onClickSearch() {
          this.loadList();
      },
      onClickSort(sortKey, asc) {
          this.sortKey = sortKey;
          this.asc = asc;
      },
      onChangePage(page) {
          this.page = page;
      },
      onClickDownload() {
          this.popup.excel = true;
      },
      onClickNew() {
          this.$router.push({ name: "ep-field-field-create" });
      },
      onClickClose() {
          const keys = Object.keys(this.popup);
          keys.map((key) => {
              this.popup[key] = false;
          });
      },
      onClickDetail(value, target) {},

      handleItemClickDetail(data) {
          this.$router.push({ name: "ep-field-field-update", params: { proj_id: this.$route.params.proj_id, postId: data.id } });
      },

      handleChangePage(/*page*/) {
          //
      },
  },
};
</script>

<style scoped></style>
